// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file_container{align-items:flex-end;max-width:none;margin:0;padding:0;list-style:none}.file_item{display:inline-block;margin-top:12px;margin-right:12px}@media(min-width:640px){.file_item{margin-top:calc(.71429vw + 7.42857px)}}@media(min-width:1200px){.file_item{margin-top:16px}}@media(min-width:640px){.file_item{margin-right:calc(.71429vw + 7.42857px)}}@media(min-width:1200px){.file_item{margin-right:16px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
